<script>
import { cn } from '@/lib/utils'

export default {
  name: 'UiInput',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const handleInput = (e) => {
      emit('update:modelValue', e.target.value)
    }

    const getClass = () => {
      return cn(
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        attrs.class ?? ''
      )
    }

    return {
      handleInput,
      getClass
    }
  }
}
</script>

<template>
  <input
    :type="type"
    :value="modelValue"
    @input="handleInput"
    :class="getClass()"
  />
</template>
